import axios from 'axios';

import { hideAll, showAll } from 'Components/domHelpers';
import validateEmail from 'Util/validateEmail';

function sendRequest(report) {
  const { loaderConfig } = window;

  if (navigator && navigator.userAgent) {
    report.userAgent = navigator.userAgent;
  }
  const request = {
    request: {
      authNone: 1,
      requestList: [
        {
          clientErrorReport: {
            type: 'sales',
            errorString: 'Contact Form',
            errorJSON: JSON.stringify(report),
          }
        }
      ],
    },
  };

  return axios.post(`${loaderConfig.API_URL}ErrorReport`, request, { timeout: loaderConfig.REQUEST_TIMEOUT });
}

const contactFields = [
  'fullName', 'company', 'conferenceID', 'email', 'phone', 'comments',
];

function setInvalid(input) {
  const el = input.parentNode;

  el.classList.add('has-error');

  const icon = el.querySelector('.form-control-feedback.validation');
  if (icon)
    icon.classList.add('tbicon-cross');
}

function clearInvalid(input) {
  const el = input.parentNode;

  el.classList.remove('has-error');

  const icon = el.querySelector('.form-control-feedback.validation');
  if (icon)
    icon.classList.remove('tbicon-cross');
}

class ContactForm {
  constructor() {
    this._button = document.querySelector('.btn-contact');
    if (!this._button) {
      return;
    }

    this._alert = document.querySelector('.alert-contact');

    this._button.onclick = () => this._onclick();
  }

  _onclick() {
    const form = document.forms.contactForm;

    form.elements.forEach(el =>  clearInvalid(el));

    let isValid = true;
    const params = {};

    contactFields.forEach(_ => params[_] = form[_].value.trim());

    if (!params.fullName.length) {
      setInvalid(form.fullName);
      isValid = false;
    }

    if (!params.email.length) {
      setInvalid(form.email);
      isValid = false;
    } else if (!validateEmail(params.email)) {
      setInvalid(form.email);
      isValid = false;
    }

    if (!params.comments.length) {
      setInvalid(form.comments);
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    this._showConfirmation();

    sendRequest(params)
      .then(res => {
      })
      .catch(err => {
      });
  }

  _showConfirmation() {
    showAll('.request-sent');
    hideAll('.form-group');
  }
}

export default function initContact() {
  const contactForm = new ContactForm();
  return contactForm;
}
